module.exports = __webpack_public_path__ + "img/step2.ca51df83.png";